import React from 'react';

/**
 * Clean Badge Component
 * Variants: 'success' | 'danger' | 'warning' | 'info' | 'neutral' | 'accent'
 */
const VARIANTS = {
    success: 'bg-emerald-50 text-emerald-700 border-emerald-200/60',
    danger: 'bg-rose-50 text-rose-700 border-rose-200/60',
    warning: 'bg-amber-50 text-amber-700 border-amber-200/60',
    info: 'bg-sky-50 text-sky-700 border-sky-200/60',
    neutral: 'bg-stone-100 text-stone-700 border-stone-200',
    accent: 'bg-stone-900 text-white border-stone-900',
};

const Badge = ({ children, variant = 'neutral', className = '', size = 'sm' }) => {
    const sizeClasses = size === 'xs' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs';
    const variantStyle = VARIANTS[variant] || VARIANTS.neutral;

    return (
        <span
            className={`inline-flex items-center gap-1 font-semibold rounded-full border transition-colors ${sizeClasses} ${variantStyle} ${className}`}
        >
            {children}
        </span>
    );
};

export default Badge;
